module.exports = __webpack_public_path__ + "static/media/mlogo.dcc7314a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/mlogo.png
 ** module id = 134
 ** module chunks = 0
 **/